<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-container class="evaluation">
		<v-layout row>
			<v-btn @click="openOfferView">
				Podgląd oferty
			</v-btn>
			<v-menu offset-y open-on-hover v-if="viewData.volunteers.length > 0">
				<template v-slot:activator="{ on }">
					<v-btn class="no-print" v-on="on">
						Wolontariusze
					</v-btn>
				</template>
				<v-list>
					<v-list-tile v-for="(volunteer, index) in viewData.volunteers" v-bind:key="index"
						@click="showVolunteerProfile(volunteer.id)">
						<v-icon class="mr-2">account_circle</v-icon>
						{{volunteer.name}} {{volunteer.surname}}
					</v-list-tile>
				</v-list>
			</v-menu>
			<v-spacer></v-spacer>
			<v-btn @click="print" class="mr-3 no-print">Wydrukuj</v-btn>
		</v-layout>

		<v-card-title class="mt-3 mb-3">
			<div>
				<h2 class="mb-3">Opinia końcowa</h2>
				<div class="evaluation-card evaluation-font-size">
					<div>
						<strong class="mr-3">Nazwa oferenta:</strong> {{viewData.mainBidder}}
					</div>
					<div>
						<strong class="mr-3">Nazwa oferty:</strong> {{viewData.offerTitle}}
					</div>
					<div>
						<strong class="mr-3">Numer oferty:</strong> {{viewData.offerCode}}
					</div>
					<div>
						<strong class="mr-3">Suma kontrolna:</strong> {{viewData.controlSum}}
					</div>
					<div class="mt-3" v-if="viewData.requestedDonations.length === 1">
						<strong class="mr-3">Wnioskowana kwota:</strong>
						{{formatMoney(viewData.requestedDonations[0])}} PLN
					</div>
					<div class="mt-3" v-else>
						<strong class="mr-3">Wnioskowane kwoty</strong>
						<div class="ml-2" v-for="(donation, index) in viewData.requestedDonations"
							v-bind:key="index">
							<strong class="mr-3">Moduł {{index + 1}}:</strong>
							{{formatMoney(donation)}} PLN
						</div>
					</div>
					<div class="mt-3">
						<strong class="mr-3">Kraj:</strong> {{viewData.country}}
					</div>
					<div v-if="viewData.extraCountries.length > 0">
						<strong class="mr-3">Kraje dodatkowe:</strong>
						{{viewData.extraCountries.join(", ")}}
					</div>
					<div v-if="viewData.committeeUser && viewData.committeeUser.fullName">
						<strong class="mr-3">Autor:</strong> {{viewData.committeeUser.fullName}}
					</div>
					<div v-if="viewData.firstSendDate">
						<strong class="mr-3">Data pierwszego wysłania:</strong> {{viewData.firstSendDate}}
					</div>
					<div v-if="viewData.latestSendDate">
						<strong class="mr-3">Data ostatniego wysłania:</strong> {{viewData.latestSendDate}}
					</div>
				</div>
			</div>
		</v-card-title>

		<hr class="ma-4">

		<h3 class="mt-4 mb-4 ml-4">Elementy opinii końcowej</h3>

		<v-layout row wrap class="mt-4 evaluation-card evaluation-font-size">
			<v-flex xs4 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Opinia formalna</strong>
				</v-layout>
				<v-layout>
					<div v-if="evaluation.formal.length === 0" class="ma-4 not-evaluation"
						style="color:blue; font-weight: bold; font-style: italic">BRAK
					</div>
					<div v-else>
						<ul v-for="(item, index) in evaluation.formal" :key="item.evaluation+'-'+index">
							<li class="ma-2">
								<span>Opinia {{index + 1}}
									<v-btn icon class="no-print" @click="openEvaluationView(item, 'formal')">
										<v-icon title="Podgląd" color="amber">description</v-icon>
									</v-btn>
								</span>
								<div>Oferta spełnia wymogi formalne:
									<span v-if="item.evaluation==='true'"
										style="color:green; font-weight: bold">TAK</span>
									<span v-else style="color:red; font-weight: bold">NIE</span>
								</div>
							</li>
						</ul>
					</div>
				</v-layout>
			</v-flex>
			<v-flex xs4 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Indywidualna opinia merytoryczna</strong>
				</v-layout>
				<v-layout>
					<div v-if="evaluation.substantive.length === 0" class="ma-4 not-evaluation"
						style="color:blue; font-weight: bold; font-style: italic">BRAK
					</div>
					<div v-else>
						<ul v-for="(item, index) in evaluation.substantive" :key="item.evaluation+'-'+index">
							<li class="ma-2">
								<span>Opinia {{index + 1}}
									<v-btn icon class="no-print" @click="openEvaluationView(item, 'substantive')">
										<v-icon title="Podgląd" color="amber">description</v-icon>
									</v-btn>
								</span>
								<div v-if="!configuration.booleanEvaluation"> Ocena punktowa:
									<span class="ml-1" style="color:blue; font-weight: bold">{{formatWithoutFixed(item.evaluation)}}</span>
								</div>
								<div v-else>Ocena
									<span v-if="item.evaluation==='true'"
										style="color:green; font-weight: bold">TAK</span>
									<span v-else style="color:red; font-weight: bold">NIE</span>
								</div>
							</li>
						</ul>
					</div>
				</v-layout>
			</v-flex>
			<v-flex xs4 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Opinia placówki</strong>
				</v-layout>
				<v-layout>
					<div v-if="evaluation.agency.length === 0" class="ma-4 not-evaluation"
						style="color:blue; font-weight: bold; font-style: italic">BRAK
					</div>
					<div v-else>
						<ul v-for="(item, index) in evaluation.agency" :key="item.evaluation+'-'+index">
							<li class="ma-2">
								<span>Opinia {{index + 1}}
									<v-btn icon class="no-print" @click="openEvaluationView(item, 'agency')">
										<v-icon title="Podgląd" color="amber">description</v-icon>
									</v-btn>
								</span>
								<div>Rekomendacja:
									<span v-if="item.evaluation==='true'"
										style="color:green; font-weight: bold">TAK</span>
									<span v-else style="color:red; font-weight: bold">NIE</span>
								</div>
							</li>
						</ul>
					</div>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-layout row wrap class="mt-4 evaluation-card evaluation-font-size">
			<v-flex xs4 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Opinia ekspercka</strong>
				</v-layout>
				<v-layout>
					<div v-if="evaluation.expert.length === 0" class="ma-4 not-evaluation"
						style="color:blue; font-weight: bold; font-style: italic">BRAK
					</div>
					<div v-else>
						<ul v-for="(item, index) in evaluation.expert" :key="item.evaluation+'-'+index">
							<li class="ma-2">
								<span>Opinia {{index + 1}}
									<v-btn icon class="no-print" @click="openEvaluationView(item, 'expert')">
										<v-icon title="Podgląd" color="amber">description</v-icon>
									</v-btn>
								</span>
								<div>Rekomendacja:
									<span v-if="item.evaluation==='true'"
										style="color:green; font-weight: bold">TAK</span>
									<span v-else style="color:red; font-weight: bold">NIE</span>
								</div>
							</li>
						</ul>
					</div>
				</v-layout>
			</v-flex>
			<v-flex xs4 class="evaluation-component" style="padding-right: 2px">
				<v-layout row>
					<strong style="height: 50px">Ocena dotychczasowej współpracy</strong>
				</v-layout>
				<v-layout>
					<div v-if="evaluation.collaboration === null || evaluation.collaboration === undefined ||
							evaluation.collaboration.evaluation === null ||
							!evaluation.collaboration.collaborationEvaluationSchemaIncluded"
						class="ma-4 not-evaluation" style="color:blue; font-weight: bold; font-style: italic">BRAK
					</div>
					<div v-else>
						<ul>
							<li class="ma-2">
								<span>Ocena
									<v-btn icon @click="openCollaborationEvaluationView(evaluation.collaboration)" class="no-print">
										<v-icon title="Podgląd" color="amber">description</v-icon>
									</v-btn>
								</span>
								<div>Ocena punktowa:
									<span class="ml-1" style="color:blue; font-weight: bold">{{formatWithoutFixed(getCollaborationPoints())}}</span>
								</div>
							</li>
						</ul>
					</div>
				</v-layout>
			</v-flex>
			<v-flex xs4 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Opinia komisji</strong>
				</v-layout>
				<v-layout>
					<div v-if="evaluation.committee !== null">
						<ul>
							<li class="ma-2">
								<span>Zbiorcza ocena ofert
									<v-btn icon class="no-print" @click="openEvaluationSummaryView()">
										<v-icon title="Podgląd" color="amber">assignment</v-icon>
									</v-btn>
								</span>

								<div>Rekomendacja:
									<span class="ml-1"
										:style="getCommitteeDecisionStyle()">{{getCommitteeDecision()}}</span>
								</div>
								<div v-if="!configuration.booleanEvaluation">

									<div>Ocena punktowa:
										<span class="ml-1" style="color:blue; font-weight: bold">{{formatWithoutFixed(evaluation.committee.points)}}</span>
									</div>
									<div class="ml-2">- {{viewData.firstCriterionName}}:
										<span class="ml-1" style="color:blue">{{formatWithoutFixed(evaluation.committee.relevancy)}}
										</span>
									</div>
									<div class="ml-2">- {{viewData.secondCriterionName}}:
										<span class="ml-1" style="color:blue">{{formatWithoutFixed(evaluation.committee.efficiency)}}
										</span>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-layout row wrap class="mt-4 evaluation-card evaluation-font-size" v-if="!configuration.booleanEvaluation">
			<v-flex xs8 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Końcowa opinia komisji:</strong>
					<div>
						<span style="color:blue; font-weight: bold" class="ml-2">{{formatWithoutFixed(getFinalPointsSum())}}</span>
					</div>
				</v-layout>
				<v-layout style="height: 24px">
					<v-flex xs9>
						W tym:
					</v-flex>
					<v-flex xs3 class="no-print">
						<b>Uwzględnij</b>
					</v-flex>
				</v-layout>
				<v-layout>
					<ul style="width: 100%">
						<li class="ma-1">
							<v-layout style="height: 24px">
								<v-flex xs9>
									<span>Średnia punktacja opiniujących:</span>
									<span style="color:blue; font-weight: bold" class="ml-2">{{formatWithoutFixed(getSubstantiveAverage())}}</span>
								</v-flex>
								<v-flex xs3>
									<v-checkbox v-model="viewData.includeSubstantiveAverageIntoFinalGrade"
										:disabled="configuration.disabled && !configuration.ministerDecisionEnabled" style="margin: 0 0 0 24px;"/>
								</v-flex>
							</v-layout>
						</li>
						<li class="ma-1">
							<v-layout style="height: 24px">
								<v-flex xs9>
									<span>Punktacja komisji:</span>
									<span style="color:blue; font-weight: bold" class="ml-2">{{formatWithoutFixed(getCommitteePoints())}}</span>
								</v-flex>
								<v-flex xs3/>
							</v-layout>
						</li>
						<li class="ma-1">
							<v-layout style="height: 24px">
								<v-flex xs9>
									<span>Ocena dotychczasowej współpracy:</span>
									<span style="color:blue; font-weight: bold" class="ml-2">{{formatWithoutFixed(getCollaborationPoints())}}</span>
								</v-flex>
								<v-flex xs3>
									<v-checkbox v-model="viewData.includeCollaborationIntoFinalGrade"
										:disabled="configuration.disabled && !configuration.ministerDecisionEnabled" style="margin: 0 0 0 24px;"/>
								</v-flex>
							</v-layout>
						</li>
					</ul>
				</v-layout>
			</v-flex>
		</v-layout>

		<div class="mt-3 mb-3">
			<vue-form-generator
				name="generator"
				ref="vfg"
				:model="evaluationData.model"
				:options="formGenerator.formOptions"
				:schema="formGenerator.currentSchema"
				v-if="viewData.showGenerator">
			</vue-form-generator>
		</div>

		<hr v-if="configuration.ministerDecisionEnabled || configuration.disabled" class="ma-4">
		<h3 v-if="configuration.ministerDecisionEnabled || configuration.disabled" class="mt-4 mb-4 ml-4">Decyzja ministra w sprawie finansowania projektu</h3>
		<div v-if="configuration.ministerDecisionEnabled || configuration.disabled" class="evaluation-card evaluation-font-size">
			<v-flex xs1 ml-5 mb-3>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<div v-on="on">
							<v-checkbox
								aria-label="reserved"
								v-model="viewData.reserved"
								label="Rezerwa"
								:disabled="!configuration.ministerDecisionEnabled">
							</v-checkbox>
						</div>
					</template>
					<span>
						Umieszczenie projektu na liście rezerwowej oznacza decyzję o nieprzyznaniu środków
					</span>
				</v-tooltip>
			</v-flex>

			<v-layout row wrap>
				<template v-for="(donation, index) in viewData.requestedDonations">
					<v-flex xs6 :key="donation+'-'+index">
						<h3 v-if="viewData.requestedDonations.length > 1" class="mb-3">Moduł {{index + 1}}</h3>
						<v-layout row>
							<v-flex xs4 mt-4>
								<strong>Przyznanie środków</strong>
							</v-flex>
							<v-flex xs6 ml-4>
								<v-select
									aria-label="minister decision"
									style="height: 60px; font-size: 10pt;"
									:disabled="!configuration.ministerDecisionEnabled"
									v-model="viewData.summaryDotations.find(el => el.moduleNumber === index + 1).ministerDecision"
									:items="['TAK', 'NIE']">
								</v-select>
							</v-flex>
						</v-layout>

						<v-expand-transition
							v-if="viewData.summaryDotations.find(el => el.moduleNumber === index + 1).ministerDecision === 'TAK'">
							<div>
								<v-layout row>
									<v-flex xs4 mt-4>
										<strong>Typ rekomendacji</strong>
									</v-flex>
									<v-flex xs6 ml-4>
										<v-select
											aria-label="recommending type"
											style="height: 60px; font-size: 10pt;"
											:disabled="!configuration.ministerDecisionEnabled"
											v-model="viewData.recommendingTypes[index]"
											item-text="name"
											item-value="id"
											:items="[{name:'W kwocie rekomendowanej', id:'RECOMMENDED_VALUE'}, {name: 'W kwocie zmienionej', id: 'CHANGED_VALUE'}]"
											v-on:change="setDonationIfNecessary(index + 1)">
										</v-select>
									</v-flex>
								</v-layout>
								<v-layout row>
									<v-flex xs4 mt-4>
										<strong>Rekomendowana kwota</strong>
									</v-flex>
									<v-flex xs6 ml-4>
										<egranty-number-input-field
											:data-vv-name="'recommendation-donation-'+index"
											data-vv-as="Rekomendowana kwota"
											:error-messages="vErrors.collect('recommendation-donation-'+index)"
											:readonly="viewData.recommendingTypes[index] === 'CHANGED_VALUE'"
											style="font-size: 11pt;"
											suffix=" PLN"
											:disabled="!configuration.ministerDecisionEnabled || viewData.recommendingTypes[index] === 'RECOMMENDED_VALUE'"
											v-model="viewData.summaryDotations.find(el => el.moduleNumber === index + 1).dotation"
										/>
									</v-flex>
								</v-layout>
								<div v-if="showJustificationField(index)">
									<v-layout row>
										<v-flex mt-4 mb-4>
											<strong>Uzasadnienie modyfikacji kwoty</strong>
										</v-flex>
									</v-layout>
									<v-layout row>
										<v-flex ml-3 mr-3>
											<div v-if="configuration.ministerDecisionEnabled" class="no-print">
												<v-textarea
													browser-autocomplete="off"
													solo
													rounded
													auto-grow
													row-height="10"
													:data-vv-name="'donation-justification-'+index"
													data-vv-as="Uzasadnienie modyfikacji kwoty"
													:error-messages="vErrors.collect('donation-justification-'+index)"
													v-validate="'required|min:10'"
													placeholder="Uzasadnienie modyfikacji kwoty"
													background-color="grey lighten-3"
													v-model="viewData.summaryDotations.find(el => el.moduleNumber === index + 1).justification"
													aria-label="summary donation change justification">
												</v-textarea>
											</div>
											<div v-else class="no-print">
												{{viewData.summaryDotations.find(el =>
													el.moduleNumber === index + 1).justification}}
											</div>
											<div class="d-none print-only">
												{{viewData.summaryDotations.find(el =>
													el.moduleNumber === index + 1).justification}}
											</div>
										</v-flex>
									</v-layout>
								</div>
							</div>
						</v-expand-transition>
					</v-flex>
				</template>
			</v-layout>
		</div>

		<hr class="ma-4">

		<h3 class="mt-4 mb-4 ml-4 information-meeting-heading">Informacje o posiedzeniu</h3>
		<div class="evaluation-card information-meeting evaluation-font-size">

			<v-layout row wrap>
				<v-flex xs6>
					<v-layout row>
						<v-flex xs4 mt-4>
							<strong>Prowadzący posiedzenie</strong>
						</v-flex>
						<v-flex xs6 ml-4>
							<v-select
								style="font-size: 11pt;"
								aria-label="conference leader"
								data-vv-name="conferenceLeader"
								data-vv-as="Prowadzący posiedzenie"
								:error-messages="vErrors.collect('conferenceLeader')"
								v-validate="'required'"
								v-model="viewData.conferenceLeader"
								:items="viewData.conferenceMembers"
								:disabled="configuration.disabled"
								item-text="fullName"
								item-value="id"
								data-vv-validate-on="none"
								return-object>
							</v-select>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs6>
					<v-layout row>
						<v-flex xs4 mt-4>
							<strong>Osoba opiniująca</strong>
						</v-flex>
						<v-flex xs6 ml-4>
							<!-- ktoś kto ma uprawnienia do zmiany decyzji ministra, ma mieć możliwość zmiany osoby opiniującej-->
							<v-select v-if="configuration.ministerDecisionEnabled"
								style="font-size: 11pt;"
								aria-label="committeeUser"
								data-vv-name="committeeUser"
								data-vv-as="Osoba opiniująca"
								:error-messages="vErrors.collect('committeeUser')"
								v-validate="'required'"
								v-model="viewData.committeeUser"
								:items="viewData.conferenceMembers"
								item-text="fullName"
								item-value="id"
								data-vv-validate-on="none"
								return-object>
							</v-select>
							<v-text-field v-else
								class="no-print"
								browser-autocomplete="off"
								style="font-size: 11pt;"
								readonly
								aria-label="author"
								:disabled="configuration.disabled"
								v-model="viewData.committeeUser.fullName">
							</v-text-field>
							<v-select
								class="d-none print-only"
								style="font-size: 11pt;"
								:disabled="configuration.disabled"
								v-model="viewData.committeeUser.fullName"
								:items="[viewData.committeeUser.fullName]"
								return-object>
							</v-select>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout row wrap>
				<v-flex xs6>
					<v-layout row>
						<v-flex xs4 mt-4>
							<strong>Uczestnicy</strong>
						</v-flex>
						<v-flex xs6 ml-4>
							<div v-if="viewData.conferenceMembers !== null" class="ma-2 mt-4">
								<ul v-for="member in viewData.conferenceMembers" :key="member.id">
									<li>{{member.fullName}}</li>
								</ul>
							</div>
							<div v-else class="ma-4 not-evaluation"
								style="color:blue; font-weight: bold; font-style: italic">BRAK
							</div>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs6>
					<v-layout row>
						<v-flex xs4 mt-4>
							<strong>Data posiedzenia</strong>
						</v-flex>
						<v-flex xs6 ml-4>
							<v-menu
								ref="conferenceDateMenu"
								v-model="conferenceDateMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="viewData.conferenceDate"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										style="font-size: 11pt;"
										data-vv-name="conferenceDate"
										data-vv-as="Data posiedzenia"
										aria-label="conference date"
										:error-messages="vErrors.collect('conferenceDate')"
										v-validate="'required'"
										data-vv-validate-on="none"
										v-model="viewData.conferenceDate"
										:disabled="configuration.disabled"
										readonly
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker :first-day-of-week="1"
									v-model="viewData.conferenceDate" no-title scrollable locale="pl-PL">
									<v-spacer></v-spacer>
									<v-btn flat color="primary" @click="conferenceDateMenu = false">Powrót</v-btn>
									<v-btn flat color="primary"
										@click="$refs.conferenceDateMenu.save(viewData.conferenceDate)">OK
									</v-btn>
								</v-date-picker>
							</v-menu>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</div>

		<v-btn @click="validateAndShowDialog" v-if="!configuration.disabled" color="success"
			class="no-print">
			<v-icon class="mr-2 white--text">send</v-icon>
			Wyślij
		</v-btn>

		<v-btn @click="saveEvaluation" v-if="!configuration.disabled || configuration.ministerDecisionEnabled" color="info" class="no-print">
			<v-icon class="mr-2 white--text">save</v-icon>
			Zapisz ocenę
		</v-btn>

		<evaluation-confirmation-dialog :action="send" :dialog-model="viewData.sendEvaluationDialog"
			@close-confirmation="viewData.sendEvaluationDialog = false"
			action-label="Wyślij" content="Upewnij się, że wypełniłeś poprawnie formularz zanim zatwierdzisz ocenę.
				Po zatwierdzeniu nie będzie możliwości edycji!" header="Wysyłka oceny" icon="send"/>
	</v-container>
</template>

<script>
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Api} from "@/api";
	import {FinalEvaluation} from "@/api/generated/FinalEvaluation";
	import {PublicContestEvaluation} from "@/api/generated/PublicContestEvaluation";
	import EvaluationConfirmationDialog from "../../EvaluationConfirmationDialog";
	import {Numbers} from "@/utils/Numbers";
	import EgrantyNumberInputField from "../../../../../genericComponents/EgrantyNumberInputField";
	import {Files} from "@/utils/Files";

	export default {
		name: "FinalEvaluationForm",
		components: {EgrantyNumberInputField, EvaluationConfirmationDialog},
		data() {
			return {

				configuration: {
					form: "",
					disabled: false,
					booleanEvaluation: null,
					ministerDecisionEnabled: null,
				},

				evaluationData: {
					model: undefined,
				},

				viewData: {
					showGenerator: false,
					offerId: "",
					offerTitle: "",
					offerCode: "",
					controlSum: "",
					country: "",
					committeeUser: "",
					committeeId: "",
					committeeDecision: null,
          firstSendDate: '',
          latestSendDate: '',
					requestedDonations: [],
					appliedDonations: [],
					firstCriterionName: "",
					secondCriterionName: "",
					extraCountries: [],
					conferenceDate: "",
					conferenceLeader: "",
					conferenceMembers: [],
					summaryDotations: [],
					sendEvaluationDialog: false,
					volunteers: [],
					recommendingTypes: [],
					reserved: false,
          includeSubstantiveAverageIntoFinalGrade: false,
          includeCollaborationIntoFinalGrade: false,
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: [],
				},

				evaluation: {
					formal: [],
					substantive: [],
					agency: [],
					expert: [],
					committee: null,
				},

				conferenceDateMenu: false,
			};
		},

		created() {
			this.loadData();
		},

		methods: {
			async loadData() {

				await Api.syncGet(this, "/final-evaluation/configuration?contestId=".concat(this.$route.params.id), successResponse => {
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.schema);
					this.formGenerator.currentSchema = genericFormUtil.getSectionSchemaFromSchema(this.configuration.form, 0, this.configuration.disabled);
				});

				FinalEvaluation.get(this, this.$route.params.evaluationId, success => {
					this.viewData.offerTitle = success.title;
					this.viewData.offerId = success.offerId;
					this.viewData.offerCode = success.offerCode;
					this.viewData.controlSum = success.controlSum;
					this.viewData.committeeUser = success.committeeUser;
					this.configuration.booleanEvaluation = success.booleanEvaluation;
					this.configuration.ministerDecisionEnabled = success.ministerDecisionEnabled;
					this.viewData.committeeId = success.committeeId;
					this.viewData.country = success.country;
					this.viewData.volunteers = success.volunteers;
					this.viewData.committeeDecision = success.committeeDecision;
					this.viewData.extraCountries = [];
					this.viewData.reserved = success.reserved;
          this.viewData.includeSubstantiveAverageIntoFinalGrade = success.includeSubstantiveAverageIntoFinalGrade;
          this.viewData.includeCollaborationIntoFinalGrade = success.includeCollaborationIntoFinalGrade;
					this.viewData.firstCriterionName = success.firstCriterionName;
					this.viewData.secondCriterionName = success.secondCriterionName;
          this.viewData.firstSendDate = success.firstSendDate;
          this.viewData.latestSendDate = success.latestSendDate;
		 			this.viewData.mainBidder = success.mainBidder;
					success.extraCountries.forEach(country => {
						this.viewData.extraCountries.push(country);
					});
					while (this.viewData.requestedDonations.length) {
						this.viewData.requestedDonations.pop();
					}
					success.requestedDonations.forEach(donation => {
						this.viewData.requestedDonations.push(donation);
					});
					success.appliedDonations.forEach(donation => {
						this.viewData.appliedDonations.push(donation);
					});
					this.viewData.conferenceDate = success.conferenceDate;
					this.viewData.conferenceLeader = success.conferenceLeader;
					this.viewData.conferenceMembers = success.conferenceMembers;
					this.viewData.conferenceMembers.sort((a, b) => a.fullName.localeCompare(b.fullName));
					this.viewData.recommendingTypes = [];
					this.viewData.summaryDotations = success.summaryDotations;

					this.viewData.summaryDotations.forEach(item => {
						this.viewData.recommendingTypes.push(item.donationStatus);
						if (item.ministerDecision === "RECOMMENDED") item.ministerDecision = "TAK";
						else if (item.ministerDecision === "NOT_RECOMMENDED") item.ministerDecision = "NIE";
						else item.ministerDecision = undefined;
					});

					this.fillAppliedDonations(this.viewData.appliedDonations, this.viewData.summaryDotations);

					if (success.evaluationStatus === "FINISHED") {
						this.configuration.disabled = true;
					}
					if (success.filledForm === null) {
						this.evaluationData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.evaluationData.model = genericFormUtil.decodeSchema(success.filledForm);
					}
					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;

					this.getFinishedEvaluations(this.viewData.offerId);
					this.getCollaborationEvaluation(this.viewData.offerId);
					this.getOfferEvaluationPoints(this.viewData.offerId);
				});
			},

			fillAppliedDonations(applied, summary) {
				for (let index = 0; index < summary.length; index++) {
					let summaryDotation = summary.find(el => el.moduleNumber === index + 1);
					if (summaryDotation !== undefined && summaryDotation.dotation === null) {
						summaryDotation.dotation = applied[index];
					}
				}
			},

			setDonationIfNecessary(moduleNumber) {
				if (this.viewData.recommendingTypes[moduleNumber - 1] === "RECOMMENDED_VALUE") {
					this.viewData.summaryDotations.find(el => el.moduleNumber === moduleNumber).dotation = this.viewData.appliedDonations[moduleNumber - 1];
				}
				this.viewData.summaryDotations.find(el => el.moduleNumber === moduleNumber).donationStatus = this.viewData.recommendingTypes[moduleNumber - 1];
			},

			getFinishedEvaluations(offerId) {
				PublicContestEvaluation.getFinishedOfferEvaluations(this, offerId, successResponse => {
						successResponse.forEach(item => {
							this.evaluation[item.type.toLowerCase()].push(item);
						});
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych ocen", errorResponse);
					});
			},

			getCollaborationEvaluation(offerId) {
				this.reinitializeEvaluationObject();
				PublicContestEvaluation.getFinishedCollaborationEvaluation(this, offerId, successResponse => {
						this.$set(this.evaluation, "collaboration", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych oceny współpracy", errorResponse);
					});
			},

			reinitializeEvaluationObject() {
				this.evaluation = {
					formal: [],
					substantive: [],
					agency: [],
					expert: [],
					committee: null,
				};
			},

			getOfferEvaluationPoints(offerId) {
				PublicContestEvaluation.getOfferEvaluationPoints(this, offerId, successResponse => {
						this.evaluation.committee = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować ocen", errorResponse);
					});
			},

			getCommitteeDecision() {
				switch (this.viewData.committeeDecision) {
					case "RECOMMENDED":
						return "TAK";
					case "NOT_RECOMMENDED":
						return "NIE";
					case "RESERVE":
						return "REZERWA";
					default:
						return "BRAK";
				}
			},

			getCommitteeDecisionStyle() {
				switch (this.viewData.committeeDecision) {
					case "RECOMMENDED":
						return "color:green; font-weight: bold";
					case "NOT_RECOMMENDED":
						return "color:red; font-weight: bold";
					case "RESERVE":
					default:
						return "color:blue; font-weight: bold";
				}
			},

			getCommitteePoints() {
				if (!this.evaluation.committee) return 0;
				return this.evaluation.committee.points.toFixed(2) || 0;
			},

			getSubstantiveAverage() {
				let count = this.evaluation.substantive.length;
				if (count === 0) return 0;
				if (count <= 2) {
					let evaluations = this.evaluation.substantive.map(item => parseFloat(item.evaluation));
					let sum = evaluations.reduce((a, b) => a + b, 0) || 0;
					return (sum / count).toFixed(2) || 0;
				} else {
					let evaluations = this.evaluation.substantive.map(item => parseFloat(item.evaluation));
					evaluations.sort((a, b) => a - b);
					let minDiff = evaluations[1] - evaluations[0];
					for (let i = 2; i < count; ++i) {
						minDiff = minDiff < evaluations[i] - evaluations[i - 1] ? minDiff : evaluations[i] - evaluations[i - 1];
					}

					for (let i = count - 1; i > 0; --i) {
						if (evaluations[i] - evaluations[i - 1] === minDiff) {
							return ((evaluations[i] + evaluations[i - 1]) / 2).toFixed(2);
						}
					}
				}
			},

			getCollaborationPoints() {
				if (!this.evaluation.collaboration) return 0;
				return Math.round(this.evaluation.collaboration.evaluation * 2).toFixed(2) || 0;
			},

			getFinalPointsSum() {
        let finalPointsSum = parseFloat(this.getCommitteePoints());

        if (this.viewData.includeSubstantiveAverageIntoFinalGrade) {
          finalPointsSum += parseFloat(this.getSubstantiveAverage());
        }
        if (this.viewData.includeCollaborationIntoFinalGrade) {
          finalPointsSum += parseFloat(this.getCollaborationPoints());
        }

				return finalPointsSum.toFixed(2);
			},

			saveEvaluation() {
				FinalEvaluation.putData(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
					this.$messagesBus.$emit("success", "Pomyślnie zapisano ocenę", successResponse);
					this.loadData();
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać oceny", errorResponse);
				});
			},

			async send() {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (result) {
						FinalEvaluation.putFinish(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
							this.$messagesBus.$emit("success", "Ocena została wysłana", successResponse);
							this.$router.push("/app/evaluations/final");
						}, errorResponse => {
							this.viewData.sendEvaluationDialog = false;
							this.$messagesBus.$emit("error", "Nie udało się wysłać oceny", errorResponse);
						});
					} else {
						this.viewData.sendEvaluationDialog = false;
						this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane oceny");
					}
				});
			},

			prepareFormData() {
				this.prepareSummaryDotations();

				return {
					filledForm: genericFormUtil.encodeSchema(this.evaluationData.model),
					conferenceLeaderId: this.viewData.conferenceLeader !== null ? this.viewData.conferenceLeader.id : null,
					committeeUserId: this.viewData.committeeUser !== null ? this.viewData.committeeUser.id : null,
					conferenceDate: this.viewData.conferenceDate,
					summaryDotations: this.viewData.summaryDotations,
					committeeId: this.viewData.committeeId,
					reserved: this.viewData.reserved,
          includeSubstantiveAverageIntoFinalGrade: this.viewData.includeSubstantiveAverageIntoFinalGrade,
          includeCollaborationIntoFinalGrade: this.viewData.includeCollaborationIntoFinalGrade,
				};
			},

			prepareSummaryDotations() {
				let i = 0;
				this.viewData.summaryDotations.forEach(item => {
					item.donationStatus = this.viewData.recommendingTypes[i];
					i++;
					if (item.ministerDecision === "TAK") item.ministerDecision = "RECOMMENDED";
					else if (item.ministerDecision === "NIE") item.ministerDecision = "NOT_RECOMMENDED";
					else item.ministerDecision = "NOT_SET";
				});
			},

			applyGenericForm(form) {
				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.configuration.disabled);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.evaluationData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},

			async validateAndShowDialog() {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane formularza");
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (!result) {
						if (this.viewData.summaryDotations.map(item => item.dotation).some(dot => !dot)) {
							this.$messagesBus.$emit("error", "Podaj rekomendowaną kwotę");
						} else if (this.viewData.summaryDotations.some(item => item.ministerDecision === "TAK" && item.donationStatus === "CHANGED_VALUE" && !item.justification)) {
							this.$messagesBus.$emit("error", "Podaj uzasadnienie zmiany kwoty");
						} else this.$messagesBus.$emit("error", "Uzupełnij wszystkie wymagane pola");
					} else {
						this.viewData.sendEvaluationDialog = true;
					}
				});
			},

			showJustificationField (index) {
				return this.viewData.recommendingTypes[index] === 'CHANGED_VALUE' ||
					parseFloat(this.viewData.summaryDotations.find(el => el.moduleNumber === index + 1).dotation).toFixed(2)
					!== parseFloat(this.viewData.requestedDonations[index]).toFixed(2);
			},

			showVolunteerProfile(volunteerId) {
				this.$router.openInNewTab({name: "profileView", params: {userId: volunteerId}});
			},

      openOfferView() {
        this.$router.openInNewTab('/view/contest/' + this.$route.params.id + '/offer/' + this.viewData.offerId);
      },

      openEvaluationView(item, evaluationType) {
        this.$router.openInNewTab('/app/contest/' + this.$route.params.id + '/' + evaluationType + '-evaluation/' + item.id);
      },

      openEvaluationSummaryView() {
        this.$router.openInNewTab('/app/contest/' + this.$route.params.id + '/evaluation-summary/committees/' + this.viewData.committeeId);
      },

      openCollaborationEvaluationView(collaboration) {
        this.$router.openInNewTab("/view/contest/" + collaboration.publicContestId + "/collaboration-evaluation/" + collaboration.bidderId);
      },

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getEvaluationPrintUrl(
						this.$route.params.id,
						this.$route.params.evaluationId,
						"final"
					),
					"opinia_końcowa.pdf"
				);
			},
		},

		mixins: [
			Numbers,
		],
	};
</script>

<style scoped>
	.header-card-font-size {
		font-size: 14px;
	}

	@media print {
		.header-card-font-size {
			font-size: 13px;
		}

		.evaluation-font-size * {
			font-size: 13px;
		}
	}
</style>
